import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';
import { FilterCategoryEnum, FilterTypeEnum } from '@/bundles/GroupFilters/enums/FilterTypeEnum';
import { getCurrentAccountId } from '@/bundles/GroupFilters/consts';
import { getShowArchiveFilterConfig } from '@/bundles/GroupFilters/helpers/filtersConfig/getShowArchiveFilterConfig';
import { getStaticSetFilterConfig } from '@/bundles/GroupFilters/helpers/filtersConfig/getStaticSetFilterConfig';

export const getRequestFilters = (): IFilterConfigItem[] => {
  const currentFilterId = getCurrentAccountId();

  return [
    // FilterCategoryEnum.request_details start
    {
      title: 'Request Type',
      name: 'request_type',
      type: FilterTypeEnum.one_select,
      items: [
        { text: 'Feature', value: 'feature' },
        { text: 'Bug', value: 'bug' },
      ],
      category: FilterCategoryEnum.request_details,
    },
    {
      title: 'Request Status',
      name: 'request_status',
      type: FilterTypeEnum.autocomplete_multiple_select,
      items: [
        { text: 'Open', value: 'Open' },
        { text: 'Closed', value: 'Closed' },
        { text: 'Reopen', value: 'reopen' },
        { text: 'Pending', value: 'Pending' },
        { text: 'Planning', value: 'planning' },
        { text: 'QA', value: 'QA' },
        { text: 'In Progress', value: 'in-progress' }
      ],
      category: FilterCategoryEnum.request_details,
    },
    {
      title: 'Show recently completed requests (last 7 days)',
      name: 'request_recently_completed',
      type: FilterTypeEnum.switch,
      category: FilterCategoryEnum.request_details,
    },
    {
      title: 'Due Next 7 Days (excluding today)',
      name: 'request_due_next_7_days',
      type: FilterTypeEnum.switch,
      category: FilterCategoryEnum.request_details,
    },
    {
      title: 'Not in Jira',
      name: 'is_not_in_jira',
      type: FilterTypeEnum.switch,
      category: FilterCategoryEnum.request_details,
    },
    {
      title: 'Completed date',
      name: 'request_completed_date_range',
      type: FilterTypeEnum.date_range,
      category: FilterCategoryEnum.request_details,
    },
    {
      title: 'Request section',
      name: 'request_section',
      type: FilterTypeEnum.one_select,
      items: [
        { text: 'Spatial GIS', value: 'spatial-search' },
        { text: 'Companies', value: 'companies' },
        { text: 'Contacts', value: 'contacts' },
        { text: 'Occupiers', value: 'occupiers' },
        { text: 'Requirements', value: 'requirements' },
        { text: 'Properties', value: 'properties' },
        { text: 'Availabilities', value: 'availabilties' },
        { text: 'Comparables', value: 'comparables' },
        { text: 'Projects', value: 'projects' },
        { text: 'Saved Sets', value: 'savedsets' },
        { text: 'Pipelines', value: 'pipelines' },
        { text: 'Closed Deals', value: 'deals' },
        { text: 'Marketing', value: 'marketing' },
      ],
      category: FilterCategoryEnum.request_details,
    },
    [12].includes(currentFilterId || 0) ? {
      title: 'Request Account',
      name: 'request_account',
      type: FilterTypeEnum.account_multiply_select,
      category: FilterCategoryEnum.request_details,
    } : null,
    {
      title: 'Priority',
      name: 'request_priority',
      type: FilterTypeEnum.number_range,
      category: FilterCategoryEnum.request_details,
    },
    {
      title: 'Development Status',
      name: 'request_assigned',
      type: FilterTypeEnum.one_select,
      items: [
        { text: 'Assigned', value: 'assigned' },
        { text: 'Scheduled', value: 'scheduled' },
        { text: 'Unassigned', value: 'unassigned' },
        { text: 'Unscheduled', value: 'unscheduled' }
      ],
      category: FilterCategoryEnum.request_details,
    },
    {
      title: 'Assigned To',
      name: 'request_assigned_to',
      type: FilterTypeEnum.autocomplete_multiple_select,
      items: [
        { text: 'Denys Datsiuk', value: 'Denys Datsiuk' },
        { text: 'Dmytro Sych', value: 'Dmytro Sych' },
        { text: 'Kolya dokiychuk', value: 'Kolya dokiychuk' },
        { text: 'Anton Kinalevskyi', value: 'Anton Kinalevskyi' },
        { text: 'Maks Luniak', value: 'Maks Luniak' },
        { text: 'Kevin Fricke', value: 'Kevin Fricke' },
      ],
      category: FilterCategoryEnum.request_details,
    },
    {
      title: 'Due Date',
      name: 'request_due_date',
      type: FilterTypeEnum.one_select,
      items: [
        { text: 'This Week', value: 'week' },
        { text: 'This Month', value: 'month' },
        { text: 'Past Due', value: 'past' },
      ],
      category: FilterCategoryEnum.request_details,
    },
    // FilterCategoryEnum.request_details end
    // FilterCategoryEnum.created_edited start
    {
      title: 'Created/Edited Date',
      name: 'request_view_date',
      type: FilterTypeEnum.date_range,
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Created Date',
      name: 'request_created_date',
      type: FilterTypeEnum.date_range,
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Edited Date',
      name: 'request_edited_date',
      type: FilterTypeEnum.date_range,
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Created/Edited by',
      name: 'request_view',
      type: FilterTypeEnum.create_updated_by_select,
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Created by',
      name: 'request_created_by',
      type: FilterTypeEnum.create_updated_by_select,
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Edited by',
      name: 'request_edited_by',
      type: FilterTypeEnum.create_updated_by_select,
      category: FilterCategoryEnum.created_edited,
    },
    // FilterCategoryEnum.created_edited end
    getShowArchiveFilterConfig(),
    getStaticSetFilterConfig('request'),
  ].filter(Boolean) as IFilterConfigItem[];
};
